import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Mail, Phone, MapPin } from 'lucide-react';

const socialLinks = [
  { label: 'Facebook', icon: 'f' },
  { label: 'Twitter', icon: 'x' },
  { label: 'YouTube', icon: '▶' },
  { label: 'Instagram', icon: '◉' },
];

const footerLinks = {
  'Top Colleges': [
    { label: 'IIT Delhi', href: '/' },
    { label: 'IIM Ahmedabad', href: '/' },
    { label: 'AIIMS Delhi', href: '/' },
    { label: 'BITS Pilani', href: '/' },
    { label: 'NIT Trichy', href: '/' },
  ],
  'Entrance Exams': [
    { label: 'JEE Main 2026', href: '/exam-cutoff-info' },
    { label: 'NEET UG 2026', href: '/exam-cutoff-info' },
    { label: 'CAT 2026', href: '/exam-cutoff-info' },
    { label: 'GATE 2026', href: '/exam-cutoff-info' },
    { label: 'CLAT 2026', href: '/exam-cutoff-info' },
  ],
  'Quick Links': [
    { label: 'College Predictor', href: '/college-predictor' },
    { label: 'Compare Colleges', href: '/compare-colleges' },
    { label: 'Course Finder', href: '/course-finder' },
    { label: 'City-wise Search', href: '/city-search' },
    { label: 'Student Counselling', href: '/counselling' },
    { label: 'Admin Panel', href: '/admin/login' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary text-secondary-foreground mt-16">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Brand column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <AppLogo size={36} />
              <span className="font-extrabold text-xl tracking-tight text-white">
                Edu<span className="text-primary">Portal</span>
              </span>
            </div>
            <p className="text-sm text-slate-300 leading-relaxed mb-5 max-w-xs">
              India&apos;s most comprehensive college discovery platform. Helping 2 million+ students find the right college every year.
            </p>
            <div className="space-y-2 text-sm text-slate-300">
              <div className="flex items-center gap-2">
                <Mail size={14} className="text-primary shrink-0" />
                <span>help@allaboutcampus.in</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone size={14} className="text-primary shrink-0" />
                <span>1800-572-9900 (Toll Free)</span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin size={14} className="text-primary shrink-0" />
                <span>New Delhi, India</span>
              </div>
            </div>
            <div className="flex items-center gap-3 mt-5">
              {socialLinks?.map((social) => (
                <button
                  key={`social-${social?.label}`}
                  className="p-2 rounded-lg bg-white/10 hover:bg-primary transition-colors text-white text-xs font-bold w-8 h-8 flex items-center justify-center"
                  aria-label={social?.label}
                >
                  {social?.icon}
                </button>
              ))}
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks)?.map(([title, links]) => (
            <div key={`footer-col-${title}`}>
              <h4 className="font-bold text-white text-sm mb-4 uppercase tracking-wider">{title}</h4>
              <ul className="space-y-2.5">
                {links?.map((link) => (
                  <li key={`footer-link-${title}-${link?.label}`}>
                    <Link
                      href={link?.href}
                      className="text-sm text-slate-300 hover:text-primary transition-colors"
                    >
                      {link?.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-400">
          <p>© 2026 All About Campus. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link href="/" className="hover:text-primary transition-colors">Privacy Policy</Link>
            <Link href="/" className="hover:text-primary transition-colors">Terms of Service</Link>
            <Link href="/" className="hover:text-primary transition-colors">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}